import { useState } from "react";
import { PageContainer } from "components";
import { SecondaryContainer as CommonContainer } from "components";
import clsx from "clsx";
import translation from "./translation";
import { useLocale, useWindowSize } from "hooks";
import Image from "components/Image";
// @ts-ignore
import PersianMap from "./components/PersianMap";
import dynamic from "next/dynamic";
import { replaceIfNotExist } from "utils/newFunction";

const EnglishMap = dynamic(() => import("./components/EnglishMap"), {
  ssr: false,
});

function Map({ className, data }) {
  const map = data?.map || {};
  const { locale, isRTL, isFA } = useLocale();
  const [activeAddress, setActiveAddress] = useState(0);
  const { width } = useWindowSize();

  const handleClick = (i) => {
    setActiveAddress(i);
  };

  return (
    <PageContainer
      useDefaultHrefLang
      className={className}
      breadCrumb={
        data?.breadcrumb?.length > 0
          ? data?.breadcrumb
          : translation[locale]?.BREADCRUMB
      }
      seo={data?.seo}
      metaTag={replaceIfNotExist(data?.metaTag, {
        title: translation[locale]?.TITLE,
      })}
    >
      <CommonContainer>
        <div className="tw-px-4 md:tw-px-0 tw-pb-[30px]">
          {map?.title && (
            <h1 className="tw-text-xl xxxl:tw-text-[26.67px] xxxl:tw-leading-[45.22px] tw-font-bold tw-text-[#344456]">
              {map?.title}
            </h1>
          )}
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-[50px] tw-mt-10">
            <div className="tw-order-2 md:tw-order-1">
              {/* {map?.title && width > responsive.md && (
                <h1 className="tw-text-xl xxxl:tw-text-[26.67px] xxxl:tw-leading-[45.22px] tw-font-bold tw-text-[#344456]">
                  {map?.title}
                </h1>
              )} */}
              <ul>
                {map?.addresses?.map?.((item, i) => (
                  <li
                    key={item?.title}
                    className="tw-mb-[52px] md:tw-mb-[50px] xxxl:tw-mb-10 last:tw-mb-0 tw-list-none"
                  >
                    <button
                      type="button"
                      className="tw-flex tw-items-center tw-group tw-bg-zero tw-border-0 tw-cursor-pointer"
                      onClick={() => handleClick(i)}
                    >
                      {item?.image && (
                        <Image
                          width={105}
                          height={70}
                          src={item?.image}
                          alt={item?.alt}
                          className="tw-object-cover tw-rounded-lg xxxl:tw-w-[139.98px] xxxl:tw-h-[93.33px]"
                        />
                      )}
                      <span
                        className={clsx(
                          "tw-text-xs md:tw-text-sm xxxl:tw-text-[17.33px] xxxl:tw-leading-8 tw-font-medium tw-text-justify group-hover:tw-text-[#007FAC]",
                          {
                            "tw-mr-5": isRTL,
                            "tw-ml-5": !isRTL,
                            "tw-text-[#007FAC]": activeAddress === i,
                          }
                        )}
                      >
                        {item?.title}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="tw-relative tw-aspect-square md:tw-aspect-auto -tw-mt-2.5 md:tw-mt-0 tw-order-1 md:tw-order-2">
              {isFA ? (
                <PersianMap map={map} activeAddress={activeAddress} />
              ) : (
                <EnglishMap map={map} activeAddress={activeAddress} />
              )}
            </div>
          </div>
        </div>
      </CommonContainer>
    </PageContainer>
  );
}

export default Map;
